export const isAbsoluteLink = (link = ''): boolean => {
  const matches = link?.match(/^(http:\/\/|https:\/\/|mailto:)/);

  return !!matches;
};
export default null;
